/* src/components/loading-spinner-fullscreen/loading-spinner-fullscreen.component.scss */
:host {
  display: block;
  cursor: wait;
}
.loading-spinner-fullscreen {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  backface-visibility: hidden;
  position: fixed;
  z-index: 10001;
  background: #fff;
  box-shadow: var(--vwui-shadow-base);
  padding: 10px;
  border-radius: 50%;
  -webkit-user-select: none;
  user-select: none;
}
.loading-spinner-fullscreen-backdrop {
  position: fixed;
  z-index: 10000;
  top: -1px;
  left: -1px;
  right: -1px;
  bottom: -1px;
  background: rgba(var(--vwui-color-dark), 0.25);
}
/*# sourceMappingURL=loading-spinner-fullscreen.component-VNC3AKRG.css.map */
